<div class="priority-and-due-date">
  <div class="due-date">
    <ts-button
      variant="secondary"
      htmlButtonType="button"
      class="min-w-26 z-0"
      [ngClass]="{ overdue: isOverdue(), 'due-set': !ignoreOverdue && value }"
      (buttonClick)="openDueDatePanel()"
      [disabled]="!canEdit"
      #dueDatePanelOrigin
    >
      <mat-icon [svgIcon]="'today'"></mat-icon>

      <span *ngIf="value">{{ value | date: 'shortDate' }}</span>
      <span *ngIf="!value">{{ notSetText }}</span>
    </ts-button>
  </div>
  <ng-template #dueDatePanel>
    <div class="tasks-details-due-date-panel">
      <mat-calendar [selected]="value" [startAt]="value" (selectedChange)="updateDueDate($event)"></mat-calendar>

      <ts-button type="stroked" *ngIf="value" (buttonClick)="removeDueDate()">
        <mat-icon [svgIcon]="'remove_circle'"></mat-icon>
        Remove {{ notSetText?.toLowerCase() }} date
      </ts-button>
    </div>
  </ng-template>
</div>
